import api from '../../config/APIConfig'

const { iAxios, apiUri } = api
const baseUrl = `${apiUri}/`

export const SengridActions = {
  enviarPin
  ,validarPin
}
function enviarPin(token,email) {
    return iAxios.get(`${baseUrl}enviarPin?Token=`+token+"&para="+email)
}
function validarPin(token,pin) {
    return iAxios.get(`${baseUrl}validarPin?Token=`+token+'&pin='+pin)
}